import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/ffsi-book.png'


const _hoisted_1 = { class: "container mb-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img-fluid",
    alt: "Buchcover"
  })
], -1)
const _hoisted_4 = { class: "col-sm-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Das Buch - neu in der 3. Auflage", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "lead" }, " Perfekt für alle Studieneinsteiger im Bereich der Informatik, Unentschlossene bei der Studienentscheidung und Interessierte. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "lead" }, " Mit vielen Beispielen, Knobeleien und Aufgaben ideal zum Selbststudium — auch ohne Vorkenntnisse. ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list-ul" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.rheinwerk-verlag.de/fit-furs-studium-informatik_6115/",
  target: "_blank",
  class: "btn btn-success"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cart2" }),
  /*#__PURE__*/_createTextVNode(" Kaufen ")
], -1)
const _hoisted_10 = { class: "row mt-5" }
const _hoisted_11 = { class: "col-md-4 clearfix" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, "Materialien", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Die Codebeispiele zum Download, ergänzende Erklärungen und Links zu weiteren Ressourcen vervollständigen die Buchinhalte. Auch Fehlerkorrekturen und Antworten auf typische Leserfragen finden Sie hier.", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list-ul" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 clearfix" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Feedback"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Hat Ihnen das Buch den Einstieg in die Informatik erleichtert? Haben Sie Fragen oder Verbesserungswünsche, Lob oder Kritik? Lassen Sie uns wissen, wie Ihnen "),
    /*#__PURE__*/_createElementVNode("em", null, "Fit fürs Studium - Informatik"),
    /*#__PURE__*/_createTextVNode(" gefällt! ")
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.rheinwerk-verlag.de/feedback/produkt/6115/",
    target: "_blank",
    class: "btn btn-success float-end"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chat-text" }),
    /*#__PURE__*/_createTextVNode(" Feedback geben ")
  ])
], -1)
const _hoisted_16 = { class: "col-md-4 clearfix" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", null, "Die Autoren", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, " Arne Boockmeyer, Philipp Fischbeck und Stefan Neubert bringen in dieses Buch Erfahrungen aus ihrer Zeit als Studenten, Wissenschaftler und Dozenten am Hasso-Plattner-Institut in Potsdam ein. Sie engagieren sich seit Jahren in zahlreichen Veranstaltungen für die Vermittlung ihres Fachs. ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_book_header = _resolveComponent("book-header")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_book_header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("p", null, [
            _createVNode(_component_router_link, {
              to: "/kapitel",
              class: "btn btn-primary"
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createTextVNode(" Themenübersicht")
              ]),
              _: 1
            }),
            _createTextVNode(_toDisplayString(' ') + " "),
            _hoisted_9
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _hoisted_13,
          _createVNode(_component_router_link, {
            to: "/kapitel",
            class: "btn btn-primary float-end"
          }, {
            default: _withCtx(() => [
              _hoisted_14,
              _createTextVNode(" Zu den Materialien")
            ]),
            _: 1
          })
        ]),
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _hoisted_18,
          _createVNode(_component_router_link, {
            to: "/autoren",
            class: "btn btn-primary float-end"
          }, {
            default: _withCtx(() => [
              _hoisted_19,
              _createTextVNode(" Über die Autoren")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}